<template>
  <div class="cardSlide">
    <div class="swiper cardSwiper" v-show="showCard">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide wow animate__slideInUp"
          :data-wow-delay="`${idx / 10}s`"
          v-for="(item, idx) in ApplicationAreas"
          :key="idx"
          @click="setId(idx)"
        >
          <router-link class="swiperLink" to="/use/one">
            <el-image
              class="swiperImg"
              fit="cover"
              :src="item.PicUrl"
              style="height: 100%"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>

            <h3>{{ item.Title }}</h3>
          </router-link>
        </div>
      </div>
    </div>
    <div class="swiperRight">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="btn-icon"
      >
        <path
          d="M2 9.49999L13.5 9.5L10.5 5.00001"
          stroke="currentColor"
          stroke-linecap="square"
        ></path>
      </svg>
    </div>
    <div class="swiperLeft">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="btn-icon icon-left"
      >
        <path
          d="M14 9.49999L2.5 9.5L5.5 5.00001"
          stroke="currentColor"
          stroke-linecap="square"
        ></path>
      </svg>
    </div>
    <!-- <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div> -->
  </div>
</template>

<script>
// import { animateCSS } from "@/utils/tool";
// import { WOW } from "wowjs";
import { judgeWindow } from "@/utils/tool.js";
export default {
  data() {
    return {
      list: [
        {
          url: "images/zy1.jpg",
          title: "航空航天",
        },
        {
          url: "images/zy2.jpg",
          title: "风电叶片",
        },
        {
          url: "images/zy3.jpg",
          title: "碳/碳复合材料",
        },
        {
          url: "images/zy4.jpg",
          title: "压力容器",
        },
        {
          url: "images/zy5.jpg",
          title: "休闲体育",
        },
        {
          url: "images/zy6.jpg",
          title: "建筑桥梁",
        },
        {
          url: "images/zy7.jpg",
          title: "汽车工业及轨道交通",
        },
        {
          url: "images/zy8.jpg",
          title: "碳纤维电缆芯",
        },
        {
          url: "images/zy9.jpg",
          title: "电子3C",
        },
      ],
      innerOpen: false,
      num: 4,
      showCard:false
    };
  },
  props: ["height", "ApplicationAreas"],
  components: {},
  methods: {
    /* addAnimate() {
      if (!this.innerOpen) {
        this.animate = true;
        this.$refs.one.style({ visibility: visibility });
        animateCSS(".swiper-slide", "slideInUp");
        this.innerOpen = true;
      }
    }, */
    setId(id) {
      sessionStorage.setItem("useId", id);
    },
    changeW() {
      this.showCard = false
      if (judgeWindow()) {
        this.num = 1;
      } else {
        this.num = 4;
      }
      this.initSwiper();
    },
    initSwiper() {
      this.showCard=true
      var swiper = new Swiper(".cardSwiper", {
        slidesPerView: this.num,
        spaceBetween: 20,
        slidesPerGroup: this.num,
        // loop: true,
        // loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiperRight",
          prevEl: ".swiperLeft",
        },
      });
    },
  },
  watch: {
    /* twoStart(newV, oldV) {
      // watch监听props里status的变化，然后执行操作
      this.innerOpen = newV;
      return this.innerOpen;
    }, */
  },
  mounted() {
    this.changeW();
    // this.initSwiper();
    // animateCSS(".swiper-slide", "slideInUp");
    /* new WOW({
      boxClass: "wow",
      animateClass: "animate__animated",
      offset: 100,
      live: false,
    }).init(); */
    window.onresize = () => {
      this.changeW();
    };
  },
};
</script>

<style lang="scss">
// style="width: 1190px; padding: 15px"
.cardSwiper {
  width: calc(100% - 120px);
}
.cardSlide {
  position: relative;
  .swiper-button-next {
    // border: 1px solid #bfbfbf;
    /* &::after {
      content: "pttttt";
      font-size: 36px;
    } */
  }
  .swiperRight,
  .swiperLeft {
    width: 50px;
    height: 50px;
    position: absolute;
    top: 45%;
    line-height: 50px;
    text-align: center;
    border: 1px solid #bfbfbf;
  }
  .swiperLeft {
    left: 0;
    &:hover {
      color: #fff;
      border: 1px solid #d71820;
      background: #d71820;
    }
  }
  .swiperRight {
    right: 0;
    &:hover {
      color: #fff;
      border: 1px solid #d71820;
      background: #d71820;
    }
  }
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  height: 600px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  transition: all 0.5s;
  &:hover {
    // animation: pulse;
    // animation-duration: 1s;
    transform: scale(1.03);

    h3 {
      background: #d71820;
      color: #fff;
    }
  }
  h3 {
    text-align: center;
    transition: all 0.5s;
    font-weight: 400;
    background: #f9f9f9;
    width: 100%;
    height: 60px;
    line-height: 60px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
.swiperLink {
  display: block;
  width: 100%;
  height: 100%;
}
</style> 